import { createStore } from 'vuex'
import axios from 'axios'
import config from './config'
// eslint-disable-next-line no-unused-vars
import MockData from '../js/mock';

export default createStore({
  state: {
    debug: false,
    debugtext: '',
    show: true,
    thanksshow: false,
    loads: [],
    sms_slide_index: 1,
    pindex: undefined,
    error: {
      show: false,
      title: '',
      text: '',
      btnText: ''
    },
    fileLink: undefined,
    id: undefined,
    sendURL: '',
    exampleLink: '',
    slidenumber: 0,
    lastslidenumber: 2,
    code: '',
    smsOk: false,
    slidetitles: [
      'Привет! <br>Давайте познакомимся!',
      'На Ваш номер отправлен&nbsp;код',
      'Спасибо! <br>ваш договор № айдишник-указан-в-сторе оплачен <br>и направлен на электронную почту',
    ],
    DaData: {
      token: 'd19d3963dafe68db009a421b3baaf979385ab67b',
      urls: {
        FIO: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fio',
      }
    },
    client: {
      guid: '',
      fullname: '',
      birthdate: '',
      tel: '',
      email: '',
      agreement: false
    }
  },
  mutations: {
    setPindex(state, val) {
      state.pindex = val
    },
    setCode(state, val) {
      state.code = val
    },
    setDebug(state, val) {
      state.debug = val
      console.log('debug' + val)
    },
    setDebugText(state, val) {
      state.debugtext = val
      console.log('debugtext ' + val)
    },
    setFileLink(state, val) {
      state.fileLink = val
    },
    setError(state, obj) {
      state.error = { ...state.error, ...obj }
    },
    setExampleLink(state, val) {
      state.exampleLink = val
    },
    addLoad(state, val) {
      state.loads = [...state.loads, val]
    },
    removeLoad(state, val) {
      state.loads = state.loads.filter(el => el != val)
    },
    setSmsOk(state, val) {
      state.smsOk = val
    },
    setSlide(state, val) {
      if (val < 0)
        val = 0
      if (val > state.lastslidenumber)
        val = state.lastslidenumber
      state.slidenumber = val
    },
    nextSlide(state) {
      if (state.slidenumber < state.lastslidenumber)
        state.slidenumber++
    },
    prevSlide(state) {
      if (state.slidenumber > 0 && state.slidenumber != state.lastslidenumber)
        state.slidenumber--
      else
        state.show = false
    },
  },
  getters: {
    loading(state) {
      return state.loads.length ? true : false
    },
    noflat(state) {
      return state.client.object.type == 'Дом'
    },
    isAddressOk(state, getters) {
      if (!state.client.object.address.text) return false
      if (!state.client.object.address.house) return false
      if (!getters.noflat && !state.client.object.address.flat) return false
      return true
    },
    isLastSlide(state) {
      return state.slidenumber == state.lastslidenumber
    },
    buttonText() {
      return 'Далее'
    }
  },
  actions: {
    async loaderAfterMap({ commit }) {
      commit('addLoad', 'loaderAfterMap')
      //await await new Promise(r => setTimeout(r, 2000))
      //Пример вызова окна ошибки:
      /*commit('setError', {
        title: 'Ошибка!', 
        text: 'Что-то пошло не так',
        btnText: 'Ок',
        show: true
      })*/
      commit('removeLoad', 'loaderAfterMap')
    },
    async getExampleLink({ state, commit }) {
      commit('addLoad', 'getExampleLink')

      //TODO получение урла образца
      //await await new Promise(r => setTimeout(r, 2000))
      await axios.post(config.apiPath + config.path.sendInfo, state.client)
        .then(response => {
          console.log(response)
          let errortext
          if (response.data.messages && response.data.messages.length)
            errortext = response.data.messages.map(el => el.message).join('\n')
          commit('setDebugText', JSON.stringify(response, null, 2))
          if (response) {
            if (response.data.status === 'OK') {
              state.guid = response.data.guid;
              //localStorage.setItem('policyNumber', response.policyNumber);
              if (response.data.guid) {
                console.log('OK')
                commit('removeLoad', 'getExampleLink')
                commit('setExampleLink', config.apiPath + config.path.getFile + "?guid=" + response.data.guid)
                //localStorage.setItem('guid', response.guid);
                //localStorage.setItem('guid_timestamp', JSON.stringify(new Date().getTime()));
              }
            } else if (response.data.status === 'error' /*&& (response?.data?.server?.status)*/) {
              commit('removeLoad', 'getExampleLink')
              commit('setError', {
                title: 'Ошибка!',
                text: errortext || response?.data?.server?.message,
                btnText: 'Ок',
                show: true
              })
            } else {
              commit('removeLoad', 'getExampleLink')
              commit('setError', {
                title: 'Ошибка!',
                text: errortext || 'Сервер не доступен.' || '',
                btnText: 'Ок',
                show: true
              })
            }
          }
          //console.log(config.apiPath+config.path.getFile+"?guid="+response.data.guid)

        }).catch((err) => {
          console.log(err)
          commit('setDebugText', JSON.stringify(err, null, 2))
          commit('removeLoad', 'getExampleLink')
          commit('setError', {
            title: 'Ошибка!',
            text: 'Сервер не доступен.',
            btnText: 'Ок',
            show: true
          })
        });

    },
    async sendSMScode({ state, commit }) {
      commit('addLoad', 'sendSMScode')
      // await new Promise(r => setTimeout(r, 2000))

      // await axios.post(config.apiPath + config.path.getCode, state.client).then(response => {
      await axios.post(config.path.getCode, state.client).then(response => {
        console.log(response)
        let errortext
        if (response.data.messages && response.data.messages.length)
          errortext = response.data.messages.map(el => el.message).join('\n')
        commit('setDebugText', JSON.stringify(response, null, 2))
        if (response.data.status === "ok") {
          // console.log('Метрика: podpis_sms')
          // try{
          //   window.ym(87256559,'reachGoal','podpis_sms')
          // } catch(err) {
          commit('removeLoad', 'sendSMScode')
          console.error('ОК')
          //   console.error('Метрика не подключена')
          // }
        } else if (response?.data?.server?.status === false) {
          commit('removeLoad', 'sendSMScode')
          commit('setError', {
            title: 'Ошибка!',
            text: errortext || response.data.message || '',
            btnText: 'Ок',
            show: true
          })
        } else {
          commit('removeLoad', 'sendSMScode')
          commit('setError', {
            title: 'Ошибка!',
            text: state.responseErrors.messages.join(", "),
            btnText: 'Ок',
            show: true
          })

        }
      }).catch((err) => {
        console.log(err)
        commit('setDebugText', JSON.stringify(err, null, 2))
        commit('removeLoad', 'sendSMScode')
        commit('setError', {
          title: 'Ошибка!',
          text: 'Сервер не доступен.',
          btnText: 'Ок',
          show: true
        })
      });


    },
    async SMScodeValidation({ state, commit }, v) {

      //TODO проверка смс кода (на сервере?) + получение ссылки на оплату
      //await new Promise(r => setTimeout(r, 2000))
      if (v.length > 3) {
        commit('addLoad', 'SMScodeValidation')
        commit('setSmsOk', false)
        // await axios.post(config.apiPath + config.path.confirmCode, {
        await axios.post(config.path.confirmCode, {
          code: v,
          guid: state.guid,
          //token: data.token
        }).then(async response => {
          console.log(response)
          let errortext
          if (response.data.messages && response.data.messages.length)
            errortext = response.data.messages.map(el => el.message).join('\n')
          commit('setDebugText', JSON.stringify(response, null, 2))
          if (response?.data?.server?.status === false) {
            commit('removeLoad', 'SMScodeValidation')
            commit('setError', {
              title: 'Ошибка!',
              text: errortext || response?.data?.server?.message || '',
              btnText: 'Ок',
              show: true
            })

          } else if (response.data.status === 'ERROR' /*&& response?.data?.server?.status === true*/) {
            commit('removeLoad', 'SMScodeValidation')
            commit('setError', {
              title: 'Ошибка!',
              text: errortext || '',
              btnText: 'Ок',
              show: true
            })
            //window.ym(87256559,'reachGoal', 'error');

          } else if (response.data.status === 'ok' /*&& response?.data?.server?.status === true*/) {
            commit('setSmsOk', true)
            // await axios.post(config.apiPath + config.path.getFile, state.client).then(response2 => {
            await axios.post(config.path.getFile, state.client).then(response2 => {
              console.log(response2)
              if (response2.data.link) {

                commit('setFileLink', response2.data.link) //ссылка на файл

                commit('removeLoad', 'SMScodeValidation')

                console.log("OK")
              }
              else {
                commit('removeLoad', 'SMScodeValidation')
                commit('setError', {
                  title: 'Ошибка!',
                  text: errortext || response?.data?.server?.message || '',
                  btnText: 'Ок',
                  show: true
                })
                
              }
            });

          } else if (response.data.status === 'ERROR-LIMIT' /*&& response?.data?.server?.status === true*/) {
            commit('removeLoad', 'SMScodeValidation')
            commit('setError', {
              title: 'Ошибка!',
              text: errortext || response.data.message || '',
              btnText: 'Ок',
              show: true
            })
          }
        }).catch((err) => {
          console.log(err)
          commit('setDebugText', JSON.stringify(err, null, 2))
          commit('removeLoad', 'SMScodeValidation')
          commit('setError', {
            title: 'Ошибка!',
            text: 'Сервер не доступен.',
            btnText: 'Ок',
            show: true
          })
        });
      }
      // if (v != '1111') {
      //   commit('setSmsOk', false)
      //   commit('removeLoad', 'SMScodeValidation')
      //   return 'Неверный код'
      // }
      // commit('setSmsOk', true)
      // commit('setFileLink', 'https://google.com') //ссылка на оплату
      // commit('removeLoad', 'SMScodeValidation')

      return ''
    },
  },
})
